import { DeviceType } from '../devices/types';
import { DeviceDeploymentStatus } from '../devices/types';

export const FleetViewFilterKeys = {
  ...DeviceType,
} as const;

export enum FleetViewSort {
  ATTENTION_FIRST = 'Needs Attention First',
  UPDATED_DESC = 'Most Recently Updated',
  DEPLOYED_ASC = 'Deployed Date (Old to New)',
  DEPLOYED_DESC = 'Deployed Date (New to Old)',
}

export type LiveRiskDecision = 'ACT' | 'WATCH' | 'IGNORE';

export interface LiveRiskRead {
  decision: LiveRiskDecision;
  reason: string;
  hoursLeft: number | null;
  cause: 'temperature' | 'battery' | null;
  arrival?: {
    hoursToArrival: number;
    slowHoursToArrival: number;
    trips: number;
    inTime: number | null;
    season: string | null;
  };
}

export interface LiveRiskUnavailable {
  decision: null;
  status: 'unavailable';
}

export interface FleetViewDevice {
  serialNumber: string;
  deviceDeploymentStatus: DeviceDeploymentStatus;
  deviceType: DeviceType;
  journey?: {
    _id: string;
    pid: string;
    startTime: string;
  };
  lastKnownSensorData?: {
    battery: number;
    tempC: number;
    timestamp: string;
  };
  lastKnownLocation?: {
    lat: number;
    long: number;
    timestamp: string;
  };
  temperatureExcursions: {
    eventStart: string;
    eventEnd?: string | null;
    eventDetails?: object;
  }[];
  addressName?: string;
  liveRisk?: LiveRiskRead | LiveRiskUnavailable;
  outlook?: {
    outsideC: number | null;
    aheadMinC: number | null;
    aheadMaxC: number | null;
    drive: { hours: number; km: number } | null;
  };
}
